export const DEFAULT_ACTION_ICON_SIZE = 36;
